import React, { FC } from 'react';
import {
    TwitterShareButton,
    TwitterIcon,
} from 'react-share';


type Props = {
    title?: string;
    url: string;
    size?: number;
};


export const Twitter: FC<Props> = ({ title, url, size }) => {
    return (
        <TwitterShareButton url={url} title={title}>
            <TwitterIcon size={size ? size : 56} round />
        </TwitterShareButton>
    );
};
